import React, {useEffect, useState} from 'react';
import styles from './styles';

import AxlDatePicker from "../../AxlDatePicker";
import moment from "moment/moment";
import {withStyles} from '@material-ui/core/styles';
import {ModalDialog} from "../../Modal";
import {Container, Grid, Typography} from "@material-ui/core";


const ClaimDownloadReport = (props) => {

    const {classes, open, onCancel, onSubmit, displayErrors, disableSubmit, generating, downloadUrl} = props;
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();


    const handleChangeDate = (name, date) => {
        if (name === 'startDate') {
            if(date) {
                setStartDate(date.format("yyyy-MM-DD"));
            }else {
                setStartDate(null);
            }
        } else if (name === 'endDate') {
            if(date) {
                setEndDate(date.format("yyyy-MM-DD"));
            }else {
                setEndDate(null);
            }
        }
    }

    useEffect(() => {
        if(open){
            setStartDate(null);
            setEndDate(null);
        }
    }, [open]);


    return (
        <ModalDialog
            open={open}
            hideClose={true}
            onClose={onCancel}
            onOk={() => onSubmit(startDate, endDate)}
            okLabel={'DOWNLOAD'}
            title={"Download Report"}
            classes={classes}
            error={displayErrors}
            disabledOk={disableSubmit}
        >
            <Container className={classes.container}>
                    <>
                        <Grid container className={classes.row}>
                            <Grid item className={classes.col}>
                                <Typography className={classes.label}>{`Please choose the date range for your report`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.row}>
                            <Grid item className={classes.col}>
                                <AxlDatePicker
                                    label="Start Date"
                                    handleChange={(date) => handleChangeDate('startDate', date)}
                                    format="MM/DD/yyyy" value={startDate ? moment(startDate) : null}
                                    variant="inline"
                                    inputVariant="outlined"
                                    size="small"
                                    className={classes.datePicker}
                                    minDate={moment().subtract(1,'years')}
                                    maxDate={endDate ? endDate : undefined}
                                />
                            </Grid>
                            <Grid item className={classes.col}>
                                <AxlDatePicker
                                    label="End Date"
                                    handleChange={(date) => handleChangeDate('endDate', date)}
                                    format="MM/DD/yyyy" value={endDate ? moment(endDate) : null}
                                    variant="inline"
                                    inputVariant="outlined"
                                    size="small"
                                    disableToolbar={true}
                                    className={classes.datePicker}
                                    minDate={startDate ? startDate : undefined}
                                    maxDate={moment()}
                                />
                            </Grid>
                        </Grid>
                    </>
            </Container>
        </ModalDialog>

    );
}
export default withStyles(styles)(ClaimDownloadReport);

